/**
 * Multiplicador fijo de velocidad para animaciones Ana en el pipeline de leads (caída / arco / polling).
 * No configurable por usuario; ajustar solo aquí si hace falta.
 */
export const ANA_PIPELINE_MOTION_SPEED = 0.8;
